import { render, staticRenderFns } from "./ResetFormModal.vue?vue&type=template&id=61ac89b6&"
import script from "./ResetFormModal.vue?vue&type=script&lang=ts&"
export * from "./ResetFormModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports